import React from "react";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  customColor: (props) => {
    const colorValue =
      theme.palette[props.color]?.main ??
      theme.palette.common[props.color] ??
      theme.palette.text.primary;

    return {
      color: colorValue,
    };
  },
}));

const CustomIconButton = React.forwardRef(function CustomIconButton(
  { color = "primary", ...props },
  ref
) {
  const classes = useStyles({ color });
  const isBuiltIn =
    color === "default" ||
    color === "inherit" ||
    color === "primary" ||
    color === "secondary" ||
    color === "common";

  return (
    <IconButton
      {...props}
      ref={ref}
      color={isBuiltIn ? color : "inherit"}
      className={!isBuiltIn ? classes.customColor : props.className}
    />
  );
});
export default CustomIconButton;
